export default {
  "app": {
    "title": "VisSynth - AI短视频生成器"
  },
  "common": {
    "apply": "应用",
    "back": "返回",
    "cancel": "取消",
    "close": "关闭",
    "closeDialog": "关闭",
    "confirm": "确定",
    "error": "错误",
    "help": "帮助",
    "loading": "加载中...",
    "pricing": "定价",
    "product": "产品",
    "reset": "重置",
    "save": "保存",
    "startCreating": "开始创作",
    "startNow": "立即开始",
    "viewTutorial": "查看教程"
  },
  "history": {
    "tasks": {
      "delete": {
        "error": "删除任务失败"
      },
      "empty": "未找到任务",
      "loadError": "加载任务失败",
      "status": {
        "completed": "已完成",
        "failed": "失败",
        "pending": "待处理",
        "processing": "处理中"
      },
      "total_one": "{{count}} 个任务",
      "total_other": "{{count}} 个任务"
    }
  },
  "home": {
    "description": "使用AI创建精彩视频",
    "features": {
      "tools": {
        "description": "强大的编辑工具",
        "title": "高级工具"
      },
      "videoAnalysis": {
        "description": "自动分析视频",
        "title": "视频分析"
      },
      "videoProduction": {
        "description": "制作专业视频",
        "title": "视频制作"
      }
    },
    "welcome": "欢迎使用VisSynth"
  },
  "imageGeneration": {
    "title": "图像生成",
    "underDevelopment": "此功能正在开发中"
  },
  "inputBar": {
    "generating": "生成中...",
    "imageConfig": {
      "hd": "高清",
      "loading": "加载中...",
      "quality": "质量",
      "resolution": "分辨率",
      "standard": "标准",
      "title": "分镜图片参数"
    },
    "placeholder": "请输入视频文案、脚本或创意想法...",
    "productionPlaceholder": "请输入视频文案...",
    "analysisPlaceholder": "请输入视频分析请求...",
    "startEmptyScript": "开始空脚本视频",
    "startVideo": "开始你的视频",
    "title": "输入你想输入的内容, 来生成视频",
    "voiceConfig": {
      "loading": "加载中...",
      "title": "分镜声音参数",
      "voice": "音色",
      "speed": "语速"
    },
    "bgMusic": {
      "title": "背景音乐",
      "loading": "加载中...",
      "volume": "音量"
    },
    "subtitle": {
      "title": "字幕模板",
      "default": "默认模板"
    }
  },
  "passwordReset": {
    "email": "邮箱",
    "platformDescription": "AI驱动的短视频生成器",
    "sendResetEmail": "发送重置邮件",
    "resetPassword": "重置密码",
    "newPassword": "新密码",
    "confirmPassword": "确认新密码",
    "backToLogin": "记起密码了？",
    "login": "登录",
    "sendingEmail": "正在发送邮件...",
    "resettingPassword": "正在重置密码...",
    "success": {
      "emailSent": "密码重置邮件已发送，请检查您的邮箱。",
      "passwordReset": "密码重置成功！正在跳转到登录页面..."
    },
    "error": {
      "invalidEmail": "请输入有效的邮箱地址。",
      "failedToSendEmail": "发送重置邮件失败，请稍后重试。",
      "invalidResetLink": "无效或过期的重置链接，请重新请求。",
      "passwordTooShort": "密码必须至少6个字符。",
      "passwordsDoNotMatch": "密码不匹配。",
      "failedToResetPassword": "重置密码失败，请稍后重试。"
    }
  },
  "login": {
    "email": "邮箱",
    "error": {
      "googleLoginFailed": "Google登录失败",
      "invalidCredentials": "邮箱或密码错误"
    },
    "forgotPassword": "忘记密码?",
    "login": "登录",
    "logout": {
      "success": "登出成功"
    },
    "noAccount": "没有账号?",
    "orContinueWith": "或继续使用",
    "password": "密码",
    "platformDescription": "AI驱动的视频创作平台",
    "signingIn": "登录中...",
    "signup": "注册"
  },
  "payment": {
    "failure": {
      "message": "很抱歉，支付过程中出现了问题。请检查您的支付信息后重试。",
      "title": "支付失败"
    },
    "success": {
      "message": "您的支付已成功完成！感谢您的支持。",
      "title": "支付成功"
    },
    "actions": {
      "backToMembership": "返回会员中心"
    },
    "paypal": {
      "subscribeTo": "订阅",
      "secureFastPayment": "安全、快捷的海外支付方式",
      "payWithPayPal": "使用 PayPal 支付",
      "afterPaymentRedirect": "点击支付后，您将被重定向到 PayPal 完成支付",
      "processingPayment": "正在处理支付...",
      "paymentInProgress": "支付处理中，请完成PayPal支付",
      "processing": "处理中..."
    }
  },
  "membership": {
    "autoRenewal": "自动续费",
    "autoRenewalConvenient": "方便，无需担心过期",
    "choosePlan": "选择计划",
    "credits": " 积分",
    "currentBenefits": "当前权益",
    "currentPlan": "当前计划",
    "currentStatus": "当前状态",
    "daysRemaining": "剩余天数",
    "disabled": "已禁用",
    "enabled": "已启用",
    "expired": "已过期",
    "getPlan": "获取计划",
    "highestMembership": "最高会员等级",
    "loadingStatus": "加载会员状态...",
    "manualRenewalFlexible": "灵活，按需续费",
    "member": "会员",
    "monthly": "月度",
    "monthlyRemaining": "本月剩余",
    "noMembership": "无会员",
    "pleaseLogin": "请登录查看会员信息",
    "supportedPaymentMethods": "支持的支付方式",
    "upgradeTo": "升级到",
    "upgradeToUnlock": "升级解锁更多功能",
    "usageInfo": "使用信息",
    "validUntil": "有效期至",
    "yearly": "年度",
    "subscriptionType": {
      "none": "非会员",
      "basic": "基础版",
      "pro": "专业版",
      "business": "企业版",
      "unknown": "未知"
    },
    "saveMoney": "省钱",
    "features": {
      "aiGeneratedContent": "AI生成内容",
      "voiceovers": "配音",
      "basicEditingTools": "基础编辑工具",
      "emailSupport": "邮件支持",
      "storage": "存储空间",
      "taskHistories": "任务历史记录"
    },
    "descriptions": {
      "basic": "适合爱好者",
      "pro": "最受欢迎",
      "business": "适合专业人士"
    }
  },
  "navigation": {
    "home": "首页",
    "getStarted": "开始使用",
    "production": "工作流",
    "makeLongVideo": "Instant Reel",
    "canvasWorkflow": "Flow Canvas",
    "editVideo": "编辑视频",
    "tools": "工具",
    "imageGeneration": "图像生成",
    "videoGeneration": "视频生成",
    "history": "历史",
    "videoTasks": "Instant Reel",
    "settings": "设置",
    "billing": "账单",
    "loginTest": "登录测试"
  },
  "settings": {
    "settings1": "设置",
    "underDevelopment": "此功能正在开发中"
  },
  "signup": {
    "alreadyHaveAccount": "已有账号?",
    "and": "和",
    "byContinuing": "继续使用即表示您同意我们的",
    "confirmPassword": "确认密码",
    "createAccount": "创建账号",
    "creatingAccount": "创建账号中...",
    "email": "邮箱",
    "error": {
      "invalidEmail": "无效的邮箱格式",
      "passwordMismatch": "密码不匹配",
      "passwordTooShort": "密码长度不能少于6个字符"
    },
    "fullName": "全名",
    "google": "Google",
    "login": "登录",
    "orContinueWith": "或继续使用",
    "password": "密码",
    "privacyPolicy": "隐私政策",
    "signup": "注册",
    "successMessage": "账号创建成功!",
    "termsOfService": "服务条款"
  },
  "videoEdit": {
    "addScene": "添加场景",
    "clickToEditTitle": "点击编辑视频标题",
    "clickToGenerateImage": "点击生成图片",
    "composite": "合成",
    "compositeVideo": "合成视频",
    "deleteScene": "删除场景",
    "addNewScene": "添加新分镜",
    "editTitle": "编辑视频标题",
    "enterVideoTitle": "请输入视频标题",
    "export": "导出",
    "exportMaterial": "导出素材",
    "exportMaterials": "导出素材",
    "image": "图片",
    "loading": "加载中...",
    "materials": "素材",
    "narration": "旁白",
    "noScenesError": "请至少添加一个场景",
    "noTitleError": "请输入视频标题",
    "emptyFrameError": "检测到有空白帧或缺失的分镜，请确保所有分镜都有图片或视频内容",
    "noSceneDataError": "没有可用的场景数据，请先生成分镜内容",
    "sceneCount": "场景 {{count}}",
    "scenePreview": "场景预览",
    "untitledVideo": "未命名视频",
    "submittingTask": "提交任务中...",
    "subtitle": "字幕",
    "taskId": "任务ID",
    "taskSubmittedError": "提交任务失败",
    "taskSubmittedSuccess": "任务提交成功",
    "taskSubmittedSuccessWithEmail": "任务提交成功！请邮件查收！",
    "title": "标题",
    "video": "视频",
    "videoTitle": "视频标题",
    "waitForAI": "请等待AI生成内容",
    "waitForAIGeneration": "请等待AI生成内容或从历史记录加载",
    "transitionSetting": "转场设置",
    "lastSceneNoTransition": "最后一个场景不能设置转场效果",
    "onlySceneNoTransition": "当前只有一个场景，不能设置转场效果",
    "transitionType": "转场类型",
    "transitionDuration": "转场时长",
    "transitionEasing": "缓动函数",
    "transitionPreview": "转场预览",
    "previewArea": "预览区域",
    "generatingVideo": "生成视频中...",
    "endTime": "结束时间",
    "backgroundMusic": "背景音乐",
    "sceneImage": "分镜 {{sceneId}} 图片 {{imageId}}"
  },
  "videoGeneration": {
    "title": "视频生成",
    "underDevelopment": "此功能正在开发中"
  },
  "dialog": {
    "textToImage": {
      "title": "#{{sceneNumber}} - 详细提示词",
      "promptLabel": "提示词内容",
      "promptPlaceholder": "请输入图片生成的提示词...",
      "referenceImages": "参考图",
      "referenceImagesLabel": "参考上图",
      "selectedReferenceImages": "已选择 {{count}} 张参考图",
      "noReferenceImages": "暂无可用的参考图",
      "referenceImagesInstruction": "点击选择参考图（支持多选）",
      "qualityLabel": "质量",
      "resolutionLabel": "分辨率",
      "imageCountLabel": "图片数量",
      "previewLabel": "图片预览",
      "useThisImage": "使用此图",
      "generating": "生成中...",
      "imagePlaceholder": "图片 {{index}}"
    },
    "imageToVideo": {
      "title": "#{{sceneNumber}} - 图生视频",
      "videoDescription": "视频描述",
      "descriptionPlaceholder": "请输入视频描述...",
      "contextImages": "上下文图片",
      "contextImagesLabel": "上下文图片（点击选择，支持单选）",
      "selectedImages": "已选图片及角色配置",
      "videoParams": "视频参数配置",
      "durationLabel": "时长（秒）",
      "aspectRatioLabel": "宽高比",
      "resolutionLabel": "分辨率",
      "fpsLabel": "帧率",
      "cameraMovementLabel": "摄像机运动",
      "cameraMovement": {
        "static": "静态",
        "pan": "平移",
        "zoom": "缩放",
        "rotate": "旋转"
      },
      "videoStyleLabel": "视频风格",
      "videoStyle": {
        "cinematic": "电影",
        "animated": "动画",
        "realistic": "写实"
      },
      "addWatermark": "添加水印",
      "firstFrame": "首帧",
      "lastFrame": "末帧",
      "referenceImage": "参考图",
      "delete": "删除",
      "generating": "生成中...",
      "generateVideo": "生成视频"
    },
    "voiceSynthesis": {
      "title": "#{{sceneNumber}} - 旁白内容",
      "voiceText": "旁白内容",
      "textPlaceholder": "请输入旁白内容...",
      "generateVoice": "生成语音",
      "currentVoice": "当前音色",
      "audioFormat": "音频格式",
      "speechRate": "语速",
      "standard": "标准",
      "emotion": "情感",
      "neutral": "中性"
    },
    "imageSelection": {
      "title": "#{{sceneNumber}} - 图片 {{imageId}}",
      "imageInfo": "图片信息",
      "sceneId": "分镜 ID",
      "imageId": "图片 ID",
      "imageDescription": "图片描述",
      "noDescription": "无描述",
      "prompt": "生成提示词",
      "noPrompt": "无提示词",
      "imagePreview": "图片预览",
      "imagePlaceholder": "图片 {{imageId}}",
      "imageStatus": "图片状态",
      "imageGenerated": "图片已生成",
      "imageGenerating": "图片生成中...",
      "sceneNotFound": "分镜不存在",
      "tip": "提示：返回主界面点击\"提示词\"可以重新生成图片"
    }
  },
  "toast": {
    "voice": {
      "regenerateSuccess": "语音重新生成成功!",
      "regenerateError": "语音重新生成失败",
      "generatingVoice": "正在重新生成语音...\n参数:\n文本: {{text}}...\n音色: {{voice}}\n格式: {{format}}"
    },
    "imageToVideo": {
      "selectAtLeastOneImage": "请选择至少一张图片",
      "enterVideoDescription": "请输入视频描述",
      "taskSubmitted": "视频生成任务已提交，任务ID: {{taskId}}",
      "generationFailed": "视频生成失败，请稍后重试"
    },
    "video": {
      "generationSuccess": "视频生成成功!",
      "generationFailed": "视频生成失败: {{error}}",
      "loadHistoryFailed": "历史项目加载失败: {{error}}",
      "exportSuccess": "导出成功!",
      "exportFailed": "导出失败: {{error}}"
    },
    "textToImage": {
      "generationSuccess": "图片生成成功!",
      "generationFailed": "图片生成失败",
      "imageReplaced": "已使用图片 {{index}} 替换当前分镜的第一张图片"
    },
    "membership": {
      "paymentSuccess": "支付成功!",
      "paymentFailed": "支付失败，请重试",
      "subscriptionCreated": "订阅创建成功！",
      "subscriptionFailed": "创建订阅失败，请重试",
      "upgradeSuccess": "升级成功！",
      "upgradeFailed": "升级失败，请重试",
      "alreadyOnPlan": "您已经是当前计划的用户",
      "switchedToBasic": "已切换到基础版",
      "popupClosedRefreshing": "PayPal支付页面已关闭，正在刷新页面以更新支付状态...",
      "redirectedToPayPal": "已成功跳转到PayPal支付页面，请在弹出窗口中完成支付",
      "redirectedToPayPalNewTab": "已跳转到PayPal支付页面，请在新标签页中完成支付"
    },
    "common": {
      "unknownError": "发生未知错误",
      "processing": "处理中...",
      "success": "成功!",
      "error": "错误!"
    }
  },
  "errorBoundary": {
    "componentFailed": "组件加载失败",
    "unknownError": "发生未知错误"
  },
  "tutorial": {
    "title": "🎬 开始生成你的视频",
    "description": "在下方输入框中描述你的视频创意，AI将自动为你生成分镜脚本",
    "example": "示例：\"帮我生成一个关于太空探索的科幻短视频脚本，包含3个分镜\"",
    "howCreate": "如何创造适合社交平台发布的AI视频",
    "step1": {
      "title": "输入您的创意",
      "englishTitle": "Input Concept",
      "items": [
        "设定核心主题内容",
        "选择旁白声音风格",
        "定义分辨率 (9:16 / 16:9)"
      ]
    },
    "step2": {
      "title": "AI生成过程分镜",
      "englishTitle": "AI Generation",
      "items": [
        "智能丰富主题，生成分镜提示词",
        "Prompt自动生成高质量图片",
        "TTS引擎自动合成旁白语音",
        "依据音频节奏自动对齐时长"
      ]
    },
    "step3": {
      "title": "编辑微调您的分镜",
      "englishTitle": "Fine-tuning",
      "items": [
        "编辑提示词生成新画面 (img2img)",
        "图片一键转视频 (Motion)",
        "添加分镜转场动画特效",
        "智能适配视频片段时长"
      ]
    },
    "step4": {
      "title": "合成最终视频",
      "englishTitle": "Final Synthesis",
      "items": [
        "多模态合成 (图/视/音/字)",
        "应用电影级转场效果",
        "导出社交平台适配长视频"
      ]
    }
  },
  "transition": {
    "fade": "淡入淡出",
    "dissolve": "溶解",
    "wipe": "擦除",
    "slide": "滑动",
    "push": "推送",
    "circlecrop": "圆形裁剪",
    "rectcrop": "矩形裁剪",
    "left": "左",
    "right": "右",
    "up": "上",
    "down": "下",
    "linear": "线性",
    "in": "缓入",
    "out": "缓出",
    "inOut": "缓入缓出"
  },
  "feedback": {
    "title": "用户反馈",
    "titleLabel": "反馈标题",
    "titlePlaceholder": "请输入反馈标题",
    "titleRequired": "反馈标题不能为空",
    "titleTooLong": "反馈标题不能超过100个字符",
    "contentLabel": "反馈内容",
    "contentPlaceholder": "请详细描述您的问题或建议...",
    "contentRequired": "反馈内容不能为空",
    "contentTooLong": "反馈内容不能超过1000个字符",
    "emailLabel": "邮箱",
    "emailPlaceholder": "请输入您的邮箱",
    "emailRequired": "邮箱不能为空",
    "invalidEmail": "邮箱格式不正确",
    "submit": "提交反馈",
    "submitSuccess": "反馈提交成功！感谢您的反馈。",
    "networkError": "网络错误，请检查您的网络连接"
  },
  "videoPlayer": {
    "preparing": "准备中...",
    "allScenesCompleted": "所有分镜播放完成",
    "play": "播放",
    "pause": "暂停"
  },
  "pricing": {
    "title": "AI服务定价",
    "subtitle": "了解我们的AI服务价格，选择最适合您的方案",
    "credits": "积分",
    "benefitType": "权益类型",
    "fetchError": "获取服务配置失败",
    "noServices": "暂无可用服务",
    "services": {
      "chat": "AI对话服务",
      "image": "图像生成服务",
      "video": "视频生成服务",
      "tts": "语音合成服务"
    },
    "faq": {
      "title": "常见问题",
      "whatAreCredits": "什么是积分？",
      "creditsDescription": "积分是我们平台的虚拟货币，用于支付AI服务费用。您可以通过购买会员或直接充值获得积分。",
      "howToPurchase": "如何购买积分？",
      "purchaseDescription": "您可以在会员中心购买会员套餐，或直接购买积分包。不同的会员套餐包含不同数量的积分。",
      "creditsExpire": "积分会过期吗？",
      "expireDescription": "积分的有效期取决于您的会员状态。会员期间，积分不会过期；会员过期后，未使用的积分将在30天后失效。"
    }
  },
  "videoEditPage": {
    "description": "描述",
    "narration": "旁白",
    "prompt": "提示词",
    "playAudio": "播放音频",
    "pauseAudio": "暂停音频",
    "clickToGenerateImage": "点击生成图片"
  },
  "videoEditorSimple": {
    "title": "Vissynth",
    "subtitle": "视频编辑器",
    "uploadVideo": "点击上传视频",
    "videoSettings": "视频设置",
    "resolution": "分辨率",
    "frameRate": "帧率",
    "duration": "时长",
    "text": "文字",
    "backgroundMusic": "背景音乐"
  },
  "canvas": {
    "uploadImage": {
      "noImage": "无图片",
      "upload": "上传",
      "unsupportedFormat": "不支持的图片格式。仅支持 JPEG/JPG, PNG, GIF, WebP",
      "fileTooLarge": "单张图片不能超过 10 MB"
    },
    "templates": {
      "dialog": {
        "title": "工作流模板",
        "categories": "模板分类",
        "noCategories": "暂无分类数据",
        "templateList": "模板列表",
        "noCategoryData": "请先获取分类数据",
        "noTemplates": "当前分类下暂无模板",
        "preview": "模板预览",
        "workflowSnippet": "工作流片段：",
        "nodes": "个节点",
        "edges": "条连接",
        "withViewport": "含视图配置",
        "use": "使用"
      }
    },
    "controlPanel": {
      "templates": {
        "title": "工作流模板",
        "button": "模板"
      }
    },
    "controls": {
      "zoomIn": "放大",
      "zoomOut": "缩小",
      "fitView": "适应视图",
      "autoLayout": "自动布局"
    },
    "dynamicPrompt": {
      "advancedMode": "高级模式",
      "template": "模板",
      "outputPrompt": "输出提示词",
      "noInputFields": "无可用输入字段"
    }
  },
  "accountInfo": {
    "title": "帐户信息",
    "underDevelopment": "帐户信息功能开发中，敬请期待..."
  },
  "subtitle": {
    "configTitle": "字幕样式配置",
    "selectTemplate": "选择模板",
    "customStyle": "自定义样式",
    "preview": "预览效果",
    "livePreview": "实时预览",
    "previewText": "这是字幕预览文本",
    "templatePreview": "字幕预览",
    "fontSettings": "字体设置",
    "fontSize": "字体大小",
    "bold": "加粗",
    "italic": "斜体",
    "underline": "下划线",
    "colorSettings": "颜色设置",
    "textColor": "文字颜色",
    "outlineColor": "边框颜色",
    "width": "宽度",
    "enableBgColor": "启用背景色",
    "positionSettings": "位置设置",
    "alignment": "对齐方式",
    "top": "顶部",
    "center": "居中",
    "bottom": "底部",
    "verticalMargin": "垂直边距"
  }
};
